"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTravelCost = exports.calculate = exports.getContractorCost = exports.getContractors = exports.getPackingMaterial = void 0;
function getPackingMaterial(move, configuration, ignoreOverrides = false) {
    var _a;
    const packingMaterialMap = new Map();
    for (const room of move.rooms) {
        if (room.predefinedId) {
            const predefinedRoom = configuration.rooms.find((r) => r.id === room.predefinedId);
            if (predefinedRoom) {
                for (const item of room.items) {
                    if (item.predefinedId) {
                        const predefinedItem = predefinedRoom.items.find((i) => i.id === item.predefinedId);
                        if (predefinedItem) {
                            for (const material of predefinedItem.packingMaterial) {
                                const amount = item.amount * material.amount;
                                if (amount > 0) {
                                    const previous = packingMaterialMap.get(material.type.id);
                                    packingMaterialMap.set(material.type.id, {
                                        amount: amount + ((previous === null || previous === void 0 ? void 0 : previous.amount) || 0),
                                        inAdvance: material.inAdvance
                                            ? amount + ((previous === null || previous === void 0 ? void 0 : previous.inAdvance) || 0)
                                            : (previous === null || previous === void 0 ? void 0 : previous.inAdvance) || 0,
                                    });
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    if (!ignoreOverrides) {
        for (const { id, amount, inAdvance } of (_a = move.packingMaterialOverrides) !== null && _a !== void 0 ? _a : []) {
            const material = configuration.packingMaterials.find((p) => p.id === id);
            if (material) {
                const existing = packingMaterialMap.get(id);
                if (existing) {
                    existing.amount = amount !== null && amount !== void 0 ? amount : existing.amount;
                    existing.inAdvance = inAdvance !== null && inAdvance !== void 0 ? inAdvance : existing.inAdvance;
                }
                else if ((amount !== null && amount !== void 0 ? amount : 0) > 0) {
                    packingMaterialMap.set(id, {
                        amount: amount || 0,
                        inAdvance: inAdvance || 0,
                    });
                }
            }
        }
    }
    return configuration.packingMaterials.map((packingMaterial) => {
        var _a, _b, _c, _d, _e, _f;
        const amount = packingMaterialMap.get(packingMaterial.id);
        if (packingMaterial.unit === "piece") {
            return {
                packingMaterial,
                amount: Math.ceil((_a = amount === null || amount === void 0 ? void 0 : amount.amount) !== null && _a !== void 0 ? _a : 0),
                inAdvance: Math.ceil((_b = amount === null || amount === void 0 ? void 0 : amount.inAdvance) !== null && _b !== void 0 ? _b : 0),
                price: Math.ceil((_c = amount === null || amount === void 0 ? void 0 : amount.amount) !== null && _c !== void 0 ? _c : 0) * packingMaterial.price,
            };
        }
        else {
            return {
                packingMaterial,
                amount: (_d = amount === null || amount === void 0 ? void 0 : amount.amount) !== null && _d !== void 0 ? _d : 0,
                inAdvance: (_e = amount === null || amount === void 0 ? void 0 : amount.inAdvance) !== null && _e !== void 0 ? _e : 0,
                price: ((_f = amount === null || amount === void 0 ? void 0 : amount.amount) !== null && _f !== void 0 ? _f : 0) * packingMaterial.price,
            };
        }
    });
}
exports.getPackingMaterial = getPackingMaterial;
function getContractors(move, configuration) {
    var _a, _b, _c, _d;
    return [
        ...((_b = (_a = move.contractors) === null || _a === void 0 ? void 0 : _a.map((contractor) => {
            var _a, _b;
            const contractorConfig = configuration.contractors.find((c) => c.id === contractor.id);
            if (!contractorConfig)
                return null;
            return {
                id: contractor.id,
                name: (_a = contractorConfig.name) !== null && _a !== void 0 ? _a : "",
                workType: (_b = contractorConfig.workType) !== null && _b !== void 0 ? _b : "other",
                count: contractor.count || 0,
                cost: contractor.cost || 0,
                contractor: contractorConfig,
            };
        }).filter((c) => !!c && (c.count > 0 || (c.workType === "other" && c.cost > 0)))) !== null && _b !== void 0 ? _b : []),
        ...((_d = (_c = move.customContractors) === null || _c === void 0 ? void 0 : _c.map((contractor) => {
            var _a, _b;
            return ({
                id: contractor.id,
                name: (_a = contractor.name) !== null && _a !== void 0 ? _a : "",
                workType: (_b = contractor.workType) !== null && _b !== void 0 ? _b : "other",
                count: contractor.count || 0,
                cost: contractor.cost || 0,
            });
        })) !== null && _d !== void 0 ? _d : []),
    ];
}
exports.getContractors = getContractors;
function getContractorCost(move, configuration, options) {
    var _a;
    return ((_a = getContractors(move, configuration)
        .map((contractor) => {
        var _a, _b, _c, _d, _e, _f;
        if (contractor.contractor) {
            const contractorConfig = contractor.contractor;
            const travelCost = contractorConfig.travelCostType === "perKilometer"
                ? options.travelDistance * contractorConfig.travelCost
                : ((_a = contractor.count) !== null && _a !== void 0 ? _a : 0) * contractorConfig.travelCost;
            return {
                id: contractor.id,
                name: contractorConfig.name,
                cost: contractorConfig.workType === "other"
                    ? contractor.cost
                    : travelCost +
                        ((_b = contractorConfig.hourlyRate) !== null && _b !== void 0 ? _b : 0) *
                            (options.travelTime + options.workingTime) *
                            ((_c = contractor.count) !== null && _c !== void 0 ? _c : 0),
                workType: contractorConfig.workType,
                count: (_d = contractor.count) !== null && _d !== void 0 ? _d : 0,
            };
        }
        else {
            return {
                id: contractor.id,
                name: contractor.name,
                cost: (_e = contractor.cost) !== null && _e !== void 0 ? _e : 0,
                workType: contractor.workType,
                count: (_f = contractor.count) !== null && _f !== void 0 ? _f : 0,
            };
        }
    })
        .filter((c) => c.cost > 0)) !== null && _a !== void 0 ? _a : []);
}
exports.getContractorCost = getContractorCost;
function calculate(move, configuration) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    const totalDrivenDistance = move.drivenDistances.reduce((sum, d) => sum + (d.distance || 0), 0);
    const totalTollDrivenDistance = move.drivenDistances.reduce((sum, d) => sum + (d.tollDistance || 0), 0);
    const travelTimeNear = totalDrivenDistance / 40;
    const travelTimeFar = totalDrivenDistance / 65;
    const totalVolumeRE = move.rooms.reduce((sum, room) => sum +
        room.items.reduce((roomSum, item) => roomSum + (item.size || 0) * (item.amount || 0), 0), 0);
    const totalVolume = totalVolumeRE / 10;
    const totalVolumeMWM = totalVolumeRE / 50;
    const assemblyTime = move.rooms.reduce((sum, room) => sum +
        room.items.reduce((roomSum, item) => roomSum +
            (item.assembly ? item.amount * (item.assemblyTime || 0) : 0) +
            (item.disassembly ? item.amount * (item.disassemblyTime || 0) : 0), 0), 0);
    const isLiftRequired = move.loadingAddresses.some((address) => address.elevator === true) ||
        move.unloadingAddresses.some((address) => address.elevator === true);
    const isTrailerRequired = isLiftRequired ||
        totalVolume > configuration.calculationParameters.trailerThreshold;
    const toll = isTrailerRequired
        ? totalTollDrivenDistance *
            ((_a = configuration.calculationParameters.truckTollWithTrailer) !== null && _a !== void 0 ? _a : 0)
        : totalTollDrivenDistance *
            ((_b = configuration.calculationParameters.truckToll) !== null && _b !== void 0 ? _b : 0);
    const packingStaff = {
        teamLeaders: (_d = (_c = move.staff) === null || _c === void 0 ? void 0 : _c.teamLeaders) !== null && _d !== void 0 ? _d : 0,
        carriers: (_f = (_e = move.staff) === null || _e === void 0 ? void 0 : _e.carriers) !== null && _f !== void 0 ? _f : 0,
        trainees: (_h = (_g = move.staff) === null || _g === void 0 ? void 0 : _g.trainees) !== null && _h !== void 0 ? _h : 0,
        temporaryEmployees: (_k = (_j = move.staff) === null || _j === void 0 ? void 0 : _j.temporaryEmployees) !== null && _k !== void 0 ? _k : 0,
    };
    const contractors = getContractors(move, configuration);
    contractors.sort((a, b) => a.name.localeCompare(b.name));
    const packingStaffCount = packingStaff.teamLeaders +
        packingStaff.carriers +
        packingStaff.trainees +
        packingStaff.temporaryEmployees +
        contractors
            .filter((c) => c.workType === "carrier")
            .reduce((sum, c) => c.count + sum, 0);
    const mwmPerHour = 0.25;
    const packingTime = packingStaffCount > 0 ? totalVolumeMWM / mwmPerHour / packingStaffCount : 0;
    const packingMaterial = getPackingMaterial(move, configuration);
    const isFar = totalDrivenDistance > 50;
    const travelTime = isFar ? travelTimeFar : travelTimeNear;
    const contractorsCost = getContractorCost(move, configuration, {
        travelDistance: totalDrivenDistance,
        travelTime,
        workingTime: packingTime,
    });
    contractorsCost.sort((a, b) => a.name.localeCompare(b.name));
    const getTime = (count, time, hourlyRate) => ({
        count,
        time,
        price: count * time * hourlyRate,
    });
    const result = {
        consultant: getTime(1, (_m = (_l = move.staff) === null || _l === void 0 ? void 0 : _l.consultantTime) !== null && _m !== void 0 ? _m : 0, configuration.staffCategories.consultant.hourlyRate || 0),
        teamLeader: {
            count: packingStaff.teamLeaders,
            time: travelTime + packingTime,
            price: packingStaff.teamLeaders *
                (travelTime + packingTime) *
                (configuration.staffCategories.teamLeader.hourlyRate || 0) +
                (contractors.some((c) => c.workType === "assembly" && c.count > 0)
                    ? 0
                    : assemblyTime *
                        (configuration.staffCategories.teamLeader.hourlyRate || 0)),
            assemblyTime: contractors.some((c) => c.workType === "assembly" && c.count > 0)
                ? 0
                : assemblyTime,
        },
        carrier: getTime(packingStaff.carriers, travelTime + packingTime, configuration.staffCategories.carrier.hourlyRate || 0),
        trainee: getTime(packingStaff.trainees, travelTime + packingTime, configuration.staffCategories.trainee.hourlyRate || 0),
        temporaryEmployee: getTime(packingStaff.temporaryEmployees, travelTime + packingTime, configuration.staffCategories.temporaryEmployee.hourlyRate || 0),
        glassPacker: getTime((_p = (_o = move.staff) === null || _o === void 0 ? void 0 : _o.glassPackers) !== null && _p !== void 0 ? _p : 0, (_r = (_q = move.staff) === null || _q === void 0 ? void 0 : _q.glassPackerTime) !== null && _r !== void 0 ? _r : 0, configuration.staffCategories.glassPacker.hourlyRate || 0),
        packingTime,
        packingStaffCount,
        packingMaterial,
        isTrailerRequired,
        isLiftRequired,
        consultantCar: ((_s = move.staff) === null || _s === void 0 ? void 0 : _s.consultantCar) !== false
            ? configuration.vehicles.consultantCar.dailyRate || 0
            : null,
        truck: isTrailerRequired
            ?
                getTravelCost(configuration.vehicles.furnitureTruck, totalDrivenDistance, packingTime + travelTime) +
                    getTravelCost(configuration.vehicles.trailer, totalDrivenDistance, packingTime + travelTime)
            :
                getTravelCost(configuration.vehicles.furnitureTruck, totalDrivenDistance, packingTime + travelTime),
        car: packingStaffCount > 2
            ? getTravelCost(configuration.vehicles.staffCar, totalDrivenDistance, packingTime + travelTime)
            : 0,
        deliveryPackingMaterial: packingMaterial.some((pm) => pm.inAdvance > 0)
            ? move.loadingAddresses
                .map((address) => { var _a, _b; return (_b = (_a = move.drivenDistances.find((d) => d.from.type === "company" &&
                d.to.type === "loadingAddress" &&
                d.to.id === address.id)) === null || _a === void 0 ? void 0 : _a.distance) !== null && _b !== void 0 ? _b : 0; })
                .reduce((sum, distance) => sum + distance * 2, 0) *
                configuration.calculationParameters.kilometerRatePackingMaterial
            : null,
        travelTimeNear,
        travelTimeFar,
        totalDrivenDistance,
        totalTollDrivenDistance,
        toll,
        totalVolume,
        totalVolumeMWM,
        lift: isLiftRequired ? configuration.vehicles.lift.dailyRate || 0 : 0,
        assemblyTime,
        totalTimeNear: travelTimeNear + packingTime + assemblyTime,
        totalTimeFar: travelTimeFar + packingTime + assemblyTime,
        contractors: contractorsCost,
        storageRent: ((((_t = move.storage) === null || _t === void 0 ? void 0 : _t.rent) || 0) / 30) *
            totalVolume *
            configuration.calculationParameters.storageRent,
        containerRent: (((_u = move.storage) === null || _u === void 0 ? void 0 : _u.containerRent) || 0) *
            configuration.calculationParameters.containerRent,
        containerHandling: ((_v = move.storage) === null || _v === void 0 ? void 0 : _v.containerHandling) ? configuration.calculationParameters.containerHandling * 2
            : 0,
        containerTransport: ((_w = move.storage) === null || _w === void 0 ? void 0 : _w.containerTransport) ? configuration.calculationParameters.containerTransport
            : 0,
        insuranceFee: (move.insuranceReplacementValue || 0) > 0
            ? Math.max(move.insuranceReplacementValue *
                configuration.calculationParameters.insuranceFactor, configuration.calculationParameters.insuranceMinimum)
            : 0,
        smallParts: move.smallParts || 0,
    };
    const staffAndTransportSum = result.consultant.price +
        (result.consultantCar || 0) +
        result.teamLeader.price +
        result.carrier.price +
        result.trainee.price +
        result.temporaryEmployee.price +
        result.truck +
        result.car +
        result.toll +
        result.lift +
        contractorsCost
            .filter((c) => c.workType === "carrier")
            .reduce((sum, c) => sum + c.cost, 0);
    const assemblySum = contractorsCost
        .filter((c) => c.workType === "assembly")
        .reduce((sum, c) => sum + c.cost, 0);
    const packagingUpfrontSum = result.glassPacker.price;
    const packingMaterialSum = packingMaterial.reduce((sum, material) => sum + material.price, 0) +
        ((_x = result.deliveryPackingMaterial) !== null && _x !== void 0 ? _x : 0);
    const noParkingZonesSum = move.loadingAddresses
        .filter((address) => address.noParkingZone)
        .reduce((sum, address) => sum +
        (address.noParkingZoneFees || 0) +
        configuration.calculationParameters.noParkingZone, 0) +
        move.unloadingAddresses
            .filter((address) => address.noParkingZone)
            .reduce((sum, address) => sum +
            (address.noParkingZoneFees || 0) +
            configuration.calculationParameters.noParkingZone, 0);
    const storageSum = result.storageRent +
        result.containerRent +
        result.containerHandling +
        result.containerTransport;
    const otherSum = (move.heavyLiftSurcharge || 0) +
        contractorsCost
            .filter((c) => c.workType === "other")
            .reduce((sum, c) => sum + c.cost, 0);
    const total = staffAndTransportSum +
        assemblySum +
        packagingUpfrontSum +
        packingMaterialSum +
        noParkingZonesSum +
        storageSum +
        otherSum +
        result.insuranceFee;
    const surcharge = (_y = move.surcharge) !== null && _y !== void 0 ? _y : 0;
    const surchargeType = (_z = move.surchargeType) !== null && _z !== void 0 ? _z : "percentage";
    const totalWithSurcharge = surchargeType === "absolute"
        ? total + surcharge
        : total * (1 + surcharge / 100);
    return {
        ...result,
        noParkingZones: noParkingZonesSum,
        total,
        absoluteSurcharge: surchargeType === "percentage" ? (total * surcharge) / 100 : surcharge,
        relativeSurcharge: surchargeType === "percentage"
            ? surcharge / 100
            : total === 0
                ? 0
                : surcharge / total,
        totalWithSurcharge,
        staffAndTransportSum,
        assemblySum,
        otherSum,
    };
}
exports.calculate = calculate;
function getTravelCost(vehicle, distance, time) {
    const hourlyRate = vehicle.hourlyRate || 0;
    const kilometerRate = vehicle.kilometerRate || 0;
    if ((hourlyRate > 0 && time > 0) || (kilometerRate > 0 && distance > 0)) {
        return hourlyRate * time + kilometerRate * distance;
    }
    return vehicle.dailyRate || 0;
}
exports.getTravelCost = getTravelCost;
//# sourceMappingURL=calculation.js.map